function productCardQuickBuySwatchSelector(value) {
  if (window.CSS && typeof window.CSS.escape === "function") {
    return `.product-card__quick-add-swatches [type="radio"][value="${window.CSS.escape(value)}"]`;
  }

  return `.product-card__quick-add-swatches [type="radio"][value="${value.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"]`;
}

function productCardInfoSwatchSelector(value) {
  if (window.CSS && typeof window.CSS.escape === "function") {
    return `.product-card__info [type="radio"][value="${window.CSS.escape(value)}"]`;
  }

  return `.product-card__info [type="radio"][value="${value.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"]`;
}

// Info swatches (under the title) are a separate radio group from the quick add
// swatches, so a colour picked there must be pushed into both quick buy surfaces:
// the desktop overlay and the quick buy modal.
document.addEventListener("change", (event) => {
  const infoSwatch = event.target.closest(".product-card__info [type='radio']");
  const productCard = infoSwatch && infoSwatch.closest("product-card");

  if (!productCard) {
    return;
  }

  // Desktop overlay: no change event is dispatched here, otherwise the quick add
  // handler below would re-dispatch to the info swatch and loop.
  const overlay = productCard.querySelector(".product-card__quick-add-overlay");

  if (overlay) {
    overlay.querySelectorAll("[data-card-size-group]").forEach((group) => {
      group.classList.toggle("is-active", group.getAttribute("data-card-size-group") === infoSwatch.value);
    });

    overlay.querySelectorAll(productCardQuickBuySwatchSelector(infoSwatch.value)).forEach((matchingSwatch) => {
      matchingSwatch.checked = true;
    });
  }

  // Quick buy modal: it fetches "/products/<handle>" on open, so pointing ?variant=
  // at the chosen colour preselects it. Looked up by id because x-modal moves itself
  // to <body> while open.
  const variantId = infoSwatch.getAttribute("data-variant-id");
  const modalTrigger = productCard.querySelector(".product-card__mobile-quick-add-button[aria-controls]");
  const modal = modalTrigger && document.getElementById(modalTrigger.getAttribute("aria-controls"));

  if (variantId && modal && modal.hasAttribute("handle")) {
    const handle = modal.getAttribute("handle").split("?")[0];
    modal.setAttribute("handle", `${handle}?variant=${variantId}`);
  }
});

document.addEventListener("change", (event) => {
  const swatch = event.target.closest(".product-card__quick-add-swatches [type='radio']");

  if (!swatch) {
    return;
  }

  // Scope to the enclosing form so this still works when the quick-buy modal is
  // teleported to <body> on open (x-modal has shouldAppendToBody === true),
  // which detaches it from the <product-card> ancestor.
  const scope = swatch.closest("form") || swatch.closest("product-card");

  if (!scope) {
    return;
  }

  scope.querySelectorAll("[data-card-size-group]").forEach((group) => {
    group.classList.toggle("is-active", group.getAttribute("data-card-size-group") === swatch.value);
  });

  scope.querySelectorAll(productCardQuickBuySwatchSelector(swatch.value)).forEach((matchingSwatch) => {
    matchingSwatch.checked = true;
  });

  // Info swatches live outside the form, still inside the product-card (desktop only).
  const productCard = swatch.closest("product-card");

  if (productCard) {
    const infoSwatch = productCard.querySelector(productCardInfoSwatchSelector(swatch.value));

    if (infoSwatch && !infoSwatch.checked) {
      infoSwatch.checked = true;
      infoSwatch.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
});

// Size buttons carry their variant in data-variant-id, but Prestige's ProductForm
// builds `new FormData(form)` without a submitter (theme.js), so the clicked
// button's own name/value never reaches cart/add.js. Copy the variant into the
// form's hidden id field on click — click always fires before submit.
document.addEventListener("click", (event) => {
  const sizeButton = event.target.closest(".product-card__size-button, .product-card__add-to-bag-button");

  if (!sizeButton || sizeButton.disabled) {
    return;
  }

  const form = sizeButton.closest("form");
  const variantId = sizeButton.getAttribute("data-variant-id");

  if (!form || !variantId) {
    return;
  }

  const idInput = form.querySelector("input[name='id']");

  if (idInput) {
    idInput.value = variantId;
  }
});
